import { colors } from '../../../../../packages';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  btnBack: {
    border: 'none',
    backgroundColor: `${colors.primary100}`,
    width: '44px !important',
    height: '44px',
    minWidth: '44px !important',
    padding: '12px',
    borderRadius: '8px',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 0px 24px 0px',
  },
  sectionHeader: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  sectionContent: {
    paddingLeft: 32,
    paddingRight: 0,
    paddingBottom: 8,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  divider: {
    height: 1,
    backgroundColor: colors.neutral100,
    width: '100%',
  },
});

export const sxStyles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #e0e0e0',
    height: 80,
    padding: '16px',
  },
  outlineBtn: {
    borderColor: `${colors.destructive300} !important`,
    '&:hover': {
      backgroundColor: `${colors.destructive50} !important`,
    },
  },
  assignBtn: {
    borderColor: `${colors.primary300} !important`,
    '&:hover': {
      backgroundColor: `${colors.primary50} !important`,
    },
  },
};
